<template>
  <div class="curr-bg" style="width: calc(100% - 32px); height: 438px; padding: 8px 16px 16px 16px">
    <div class="d-between">
      <div class="left-title d-aligncnter">
        <img class="img-24" src="@/assets/img/academic/tips.svg" style="width: 24px; height: 24px" />
        <div class="ml-4">体质测试合格率</div>
      </div>
      <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="学院" name="first"></el-tab-pane>
          <el-tab-pane label="年级" name="second"></el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <table class="left-table" cellspacing="0">
      <tr class="t-head" v-if="activeName == 'first'">
        <td class="td-1">学院</td>
        <td class="td-1">参测人数</td>
        <td class="td-1">免测人数</td>
        <td class="td-1">合格率</td>
        <td class="td-1">及格率</td>
        <td class="td-1">良好率</td>
        <td class="td-1">优秀率</td>
      </tr>
      <tr class="t-head" v-if="activeName == 'second'">
        <td class="td-1">年级</td>
        <td class="td-1">性别</td>
        <td class="td-1">参测人数</td>
        <td class="td-1">免测人数</td>
        <td class="td-1">合格率</td>
        <td class="td-1">及格率</td>
        <td class="td-1">良好率</td>
        <td class="td-1">优秀率</td>
      </tr>
    </table>
    <div
      style="height: 348px; overflow: hidden"
      @mouseenter="stopScroll"
      @mouseleave="startScroll"
      @mousemove="updatexy"
    >
      <table class="left-table" cellspacing="0" :class="{ 'animated-top': animatedTop && this.stuData.length > 8 }">
        <tr
          class="tr-data"
          :class="{ 'color-tr': getBgClass(index) }"
          v-for="(item, index) in stuData"
          :key="'stu_' + index"
          @mouseenter="showInfo(item, index)"
        >
          <template v-if="activeName == 'first'">
            <td class="td-1">{{ item.college }}</td>
            <td class="td-1">{{ item.participants }}</td>
            <td class="td-1">{{ item.reductions }}</td>
            <td class="td-1">{{ item.hgl }}%</td>
            <td class="td-1">{{ item.jgl }}%</td>
            <td class="td-1">{{ item.lhl }}%</td>
            <td class="td-1">{{ item.yxl }}%</td>
          </template>
          <template v-if="activeName == 'second'">
            <td class="td-1">{{ item.grade }}</td>
            <td class="td-1">{{ item.gender }}</td>
            <td class="td-1">{{ item.participants }}</td>
            <td class="td-1">{{ item.reductions }}</td>
            <td class="td-1">{{ item.hgl }}%</td>
            <td class="td-1">{{ item.jgl }}%</td>
            <td class="td-1">{{ item.lhl }}%</td>
            <td class="td-1">{{ item.yxl }}%</td>
          </template>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  props: ['CollegeRateList', 'GradeRateList'],
  data() {
    return {
      stuData: [],
      animatedTop: false,
      timer: null,
      flag: true,
      showInfoBox: false,
      currData: {},
      currIndex: -1,
      x: '',
      y: '',
      activeName: 'first',
    }
  },
  watch: {
    CollegeRateList: {
      handler: function () {
        if (this.activeName == 'first') {
          this.stuData = this.CollegeRateList
        } else {
          this.stuData = this.GradeRateList
        }
      },
      deep: true,
    },
    GradeRateList: {
      handler: function () {
        if (this.activeName == 'first') {
          this.stuData = this.CollegeRateList
        } else {
          this.stuData = this.GradeRateList
        }
      },
      deep: true,
    },
  },
  created() {
    if (this.activeName == 'first') {
      this.stuData = this.CollegeRateList
    } else {
      this.stuData = this.GradeRateList
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      if (this.stuData.length > 8) {
        this.animatedTop = true
        setTimeout(() => {
          this.stuData.push(this.stuData[0])
          this.stuData.shift()
          this.animatedTop = false
        }, 500)
      } else {
        this.stopScroll()
      }
    }, 2000)
  },
  computed: {
    getBgClass() {
      return function (index) {
        if (index % 2 == 0) {
          return false
        }
        return true
      }
    },
  },
  methods: {
    handleClick() {
      if (this.activeName == 'first') {
        this.stuData = this.CollegeRateList
      } else {
        this.stuData = this.GradeRateList
      }
    },
    updatexy(event) {
      this.x = event.pageX
      this.y = event.pageY
    },
    showInfo(item, index) {
      console.log('item', item)
      this.currData = item
      this.currIndex = index
    },
    stopScroll() {
      clearInterval(this.timer)
      this.timer = null
      this.showInfoBox = true
    },
    startScroll() {
      this.showInfoBox = false
      this.timer = setInterval(() => {
        if (this.stuData.length > 8) {
          this.animatedTop = true
          setTimeout(() => {
            this.stuData.push(this.stuData[0])
            this.stuData.shift()
            this.animatedTop = false
          }, 500)
        } else {
          this.stopScroll()
        }
      }, 2000)
    },
  },
}
</script>
<style scoped lang="scss">
@import '@/assets/css/academic.scss';
.animated-top {
  transition: all 0.5s;
  margin-top: -30px;
}
.left-title {
  font-size: 22px;
  margin-bottom: 8px;
}
.left-box {
  width: calc(100% - 48px);
  margin-left: 24px;

  .left-table {
    width: calc(100% - 0px);
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    border-radius: 4px;
  }
}
table {
  table-layout: fixed;
  width: 100%;
  tr td {
    text-align: center;
    height: 30px;
    // height: 3vh;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .t-head {
    width: 100%;
    background: linear-gradient(0deg, rgba(6, 88, 58, 0.0884779) -24.83%, #06583a 100%);
    height: 36px;
    // height: 4vh;
  }
  tr {
    cursor: pointer;
    width: 100%;
    .td-1 {
      width: 15%;
    }
    .td-2 {
      width: 10%;
    }
    .td-3 {
      width: 30%;
    }
    .td-4 {
      width: 30%;
    }
  }
  .color-tr {
    background: rgba(0, 122, 77, 0.2);
  }
  //   .tr-data {
  // .college-name {
  //   text-align: left;
  // }
  //   }
}
.curr-bg {
  //   margin: 16px;
  //   padding: 16px;
  height: 660px;
  margin-top: 16px;
  background: linear-gradient(0deg, rgba(0, 122, 77, 0.1) 80%, rgba(0, 122, 77, 0.1) 100%);
}
.infobox {
  position: absolute;
  z-index: 999;
  background: #ededed;
  color: #000;
  font-size: 16px;
  //   left: calc(14vw - 84px);
  padding: 16px;
  border-radius: 4px;
}
.eachinfo {
  line-height: 22px;
}
.curr-bg ::v-deep .el-tabs__item.is-active {
  //切换活动项的文字颜色
  color: #00ffa1 !important;
}
.curr-bg ::v-deep .el-tabs__active-bar {
  background-color: #00ffa1 !important; //切换活动项的长条颜色
}
.curr-bg ::v-deep .el-tabs__item {
  color: #fff; //设置修改默认蚊子颜色，背景颜色，等
}
</style>
